module.exports = __webpack_public_path__ + "static/media/mindfulness-for-financial-stress.9f8b60cb.png";